/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddAgentDeptRequest as AgentApiContractAgentDeptAddAgentDeptRequest } from '../../models/AgentApi/Contract/AgentDept/add-agent-dept-request';

export interface ApiAgentAddAgentDeptPost$Params {

/**
 * Interface language. if not defined then system default language
 */
  lang?: string;
      body?: AgentApiContractAgentDeptAddAgentDeptRequest
}

export function apiAgentAddAgentDeptPost(http: HttpClient, rootUrl: string, params?: ApiAgentAddAgentDeptPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddAgentDeptPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentAddAgentDeptPost.PATH = '/api/Agent/AddAgentDept';
